
/**
 * 绘制模块抽象类
 */

//左键取点
//移动绘制
//双击结束
//每次绘制一个，非连续绘制
//节点编辑
//中心点平移
//包围盒右上角支持旋转
import ConstantDraw from "../constants/ConstantDraw"
class IDraw {
    constructor(options) {
        options = options || {};
        this.options = options;
        this.Cesium = options.Cesium || Cesium; //Cesium对象
        this.viewer = options.viewer || viewer; //场景对象
        this.options.style = options.style || {};
    }

    getSampleHeight(position) {
        var carto = Cesium.Cartographic.fromCartesian(position);
        const height = viewer.scene.sampleHeight(carto);
        console.log(height)
    }
    /**
     * 获取鼠标坐标点
     */
    getCatesian3FromPX(px) {
        // var position = viewer.scene.pickPosition(px);
        // return position;
        var cartesian;
        var ray = this.viewer.camera.getPickRay(px);
        if (!ray) return null;
        cartesian = this.viewer.scene.globe.pick(ray, this.viewer.scene);
        return cartesian;
    }
    //合并样式
    unionStyle(ConifgStyle, style) {
        //var ConifgStyle = this.options.style; //默认配置，低级别
        var unionStyle = { ...ConifgStyle, ...style };
        return unionStyle;
    }
    //创建点
    createPoint(position, style) {
        style = style || {};
        var point = this.viewer.entities.add({
            position: position,
            point: {
                ...this.unionStyle(ConstantDraw.Style_KeyPos, style)
            }
        });
        return point;
    }

    createPointbyId(position, id) {
        var point = this.viewer.entities.add({
            id: id,
            position: position,
            point: {
                ...this.unionStyle(ConstantDraw.Style_KeyPos, {})
            }
        });
        return point;
    }

    createBillboardbyId(cartesian, id) {
        var style = ConstantDraw.Style_Billboard
        var billboard = this.viewer.entities.add({
            id: id,
            position: cartesian,
            billboard: {
                ...this.unionStyle(style)
            }
        });
        return billboard;
    }

    //创建图标
    createBillboard(cartesian, style) {
        style = style || ConstantDraw.Style_Billboard
        var billboard = this.viewer.entities.add({
            position: cartesian,
            billboard: {
                ...this.unionStyle(style)
            }
        });
        return billboard;
    }

    //创建模型
    createGltf(cartesian, uri) {
        var entity = viewer.entities.add({
            type: "gltf",
            position: cartesian,
            model: {
                uri: uri
            }
        });

        return entity;
    }

    createGltfOption(cartesian, uri) {
        return {
            type: "gltf",
            position: cartesian,
            model: {
                uri: uri
            }
        }
    }

    //创建线
    createPolyline(positions, style) {
        style = style || {};
        var $this = this;
        var positionsProperty = new $this.Cesium.CallbackProperty(function () {
            return positions;
        }, false);
        var polyline = this.viewer.entities.add({
            polyline: {
                positions: positionsProperty,
                ...this.unionStyle(ConstantDraw.Style_LineNor, style)
            }
        });
        return polyline;
    }

    //创建面
    createPolygon(positions, style) {
        style = style || {};
        var $this = this;
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            return new $this.Cesium.PolygonHierarchy(positions);
        }, false);

        var polygon = this.viewer.entities.add({
            polygon: {
                hierarchy: hierarchyProperty,
                ...this.unionStyle(ConstantDraw.Style_PolygonNor, style)
            }
        });
        return polygon;
    }

    //创建圆
    createCicle(positions) {
        var $this = this;
        var semiAxisProperty = new $this.Cesium.CallbackProperty(function () {
            var center = positions[0];
            var outline = positions[positions.length - 1];
            //半径 两点间距离
            var r = Math.sqrt(
                Math.pow(center.x - outline.x, 2) +
                Math.pow(center.y - outline.y, 2)
            );
            return r ? r : r + 1;
        }, false);

        var cicle = this.viewer.entities.add({
            position: positions[0],
            ellipse: {
                semiMinorAxis: semiAxisProperty,
                semiMajorAxis: semiAxisProperty,
                ...this.unionStyle(ConstantDraw.Style_CicleNor)
            }
        });
        return cicle;
    }

    //创建球体
    createEllipsoid(positions) {
        var $this = this;
        //半径
        var rProperty = new $this.Cesium.CallbackProperty(function () {
            var center = positions[0];
            var outline = positions[positions.length - 1];
            //半径 两点间距离
            var r = Math.sqrt(
                Math.pow(center.x - outline.x, 2) +
                Math.pow(center.y - outline.y, 2)
            );
            r = r ? r : r + 1;
            return new Cesium.Cartesian3(r, r, r);
        }, false);

        var cicle = this.viewer.entities.add({
            position: positions[0],
            ellipsoid: {
                radii: rProperty,
                material: Cesium.Color.RED.withAlpha(0.5),
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
            }
        });
        return cicle;
    }

    //创建圆锥
    createCone(positions) {
        var $this = this;
        //半径
        var bottomRadiusProperty = new $this.Cesium.CallbackProperty(function () {
            var center = positions[0];
            var outline = positions[positions.length - 1];
            //半径 两点间距离
            var r = Math.sqrt(
                Math.pow(center.x - outline.x, 2) +
                Math.pow(center.y - outline.y, 2)
            );
            r = r ? r : r + 1;
            return r;
        }, false);

        var lengthProperty = new $this.Cesium.CallbackProperty(function () {
            var center = positions[0];
            var outline = positions[positions.length - 1];
            //半径 两点间距离
            var r = Math.sqrt(
                Math.pow(center.x - outline.x, 2) +
                Math.pow(center.y - outline.y, 2)
            );
            r = r ? r : r + 1;
            return r * 4;
        }, false);
        var cicle = this.viewer.entities.add({
            position: positions[0],
            cylinder: {
                length: lengthProperty,
                bottomRadius: bottomRadiusProperty,
                topRadius: 0.0,
                material: Cesium.Color.RED.withAlpha(0.5),
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
            }
        });
        return cicle;
    }

    //创建矩形
    createRectangle(positions) {
        var $this = this;
        var coordinatesProperty = new $this.Cesium.CallbackProperty(function () {
            var coordinates = $this.Cesium.Rectangle.fromCartesianArray(positions);
            return coordinates;
        }, false)
        var $this = this;
        var rectangle = this.viewer.entities.add({
            rectangle: {
                coordinates: coordinatesProperty,
                ...this.unionStyle(ConstantDraw.Style_RectangleNor)
                //material: $this.Cesium.Color.RED.withAlpha(0.5),
                // material: "data/gg.svg",
                // //height:0,
                // rotation: 0,
                // stRotation: 0
            }
        });
        return rectangle;
    }


    //去除相邻重复点
    removeDuplicate(positions) {
        if (positions.length < 2) {
            return positions;
        }
        let res = [];
        let j = 0;
        res.push(positions[0]);
        for (let i = 1; i < positions.length; i++) {
            if (res[j].x == positions[i].x && res[j].y == positions[i].y && res[j].z == positions[i].z) {
                continue;
            }
            j++;
            res.push(positions[i]);
        }
        return res;
    }

    equalsEpsilon(point1, point2, tolerance) {
        tolerance = tolerance || 0.1; //默认容差值为0.1
        var res = Cesium.Cartesian3.equalsEpsilon(point1, point2, tolerance);
        return res;
    }

    //获取外接矩形
    // 获取四个顶点坐标
    // var west = rectangle.west;
    // var south = rectangle.south;
    // var east = rectangle.east;
    // var north = rectangle.north;
    getRectangle(positions) {
        var rectangle = Cesium.Rectangle.fromCartesianArray(positions);
        var west = rectangle.west;
        var south = rectangle.south;
        var east = rectangle.east;
        var north = rectangle.north;

        var topLeft = Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(west), Cesium.Math.toDegrees(north));
        var topRight = Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(east), Cesium.Math.toDegrees(north));
        var bottomLeft = Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(west), Cesium.Math.toDegrees(south));
        var bottomRight = Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(east), Cesium.Math.toDegrees(south));

        return [topLeft, topRight, bottomLeft, bottomRight];
    }
    cartesianToLatlng(cartesian) {
        var latlng = this.viewer.scene.globe.ellipsoid.cartesianToCartographic(cartesian);
        var lat = this.Cesium.Math.toDegrees(latlng.latitude);
        var lng = this.Cesium.Math.toDegrees(latlng.longitude);
        return [lng, lat];
    }

}

//导出
export default IDraw;